<script setup>
import { ref } from 'vue';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ContactMerge from 'dashboard/components-next/Contacts/ContactsSidebar/ContactMerge.vue';

defineProps({
  contentClass: {
    type: String,
    default: '',
  },
  selectedContact: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['goToContactsList']);

const dialogRef = ref(null);

const open = () => {
  dialogRef.value?.open?.();
};

const close = () => {
  dialogRef.value?.close?.();
};

const handleGoToContactsList = () => {
  close();
  emit('goToContactsList');
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :aria-label="$t('CONTACTS_LAYOUT.SIDEBAR.MERGE.TITLE')"
    type="edit"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    width="2xl"
  >
    <ContactMerge
      :selected-contact="selectedContact"
      :class="contentClass"
      @go-to-contacts-list="handleGoToContactsList"
      @reset-tab="close"
    />
  </Dialog>
</template>
